var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center p-5"},[_c('Circle2'),_c('h4',{staticClass:"text-dark mt-2",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.loadingText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }